"use client"

import { Provider } from "react-redux"
import { store } from "./store"
import { AuthHydrator } from "@/src/components/auth/auth-hydrator"

export default function StoreProvider({ children }: { children: React.ReactNode }) {
    return (
        <Provider store={store}>
            <AuthHydrator />
            {children}
        </Provider>
    )
}